export default "__VITE_ASSET__pdfkf1Ds__"